import React from "react";
import { Link, useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";
import { Button } from "@/components/ui/button";
import { SignOut } from "@phosphor-icons/react";

const LOGO_URL =
  "https://customer-assets-lqy194kg.emergentagent.net/job_pro-connect-315/artifacts/ws4b3em5_1.png";

const Header = () => {
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  const handleLogout = async () => {
    await logout();
    navigate("/auth");
  };

  return (
    <header
      className="sticky top-0 z-40 border-b border-[#E5E2DB] bg-[#FFFFFF]/95 backdrop-blur-sm"
      data-testid="app-header"
    >
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-3 md:px-10">
        <Link to="/" className="flex items-center gap-2" data-testid="app-logo-link">
          <img src={LOGO_URL} alt="Connect A Pro" className="h-10 w-10 object-contain" />
          <span className="sr-only">Connect A Pro</span>
        </Link>

        <nav className="flex items-center gap-3">
          {user ? (
            <>
              <Link to="/contractors">
                <Button
                  variant="ghost"
                  data-testid="header-find-pro-link"
                  className="hidden text-[#0A0F0D] hover:text-[#C65D47] md:inline-flex"
                >
                  Find a Pro
                </Button>
              </Link>
              {user.role === "admin" && (
                <Link to="/admin">
                  <Button
                    variant="ghost"
                    data-testid="header-admin-link"
                    className="text-[#0A0F0D] hover:text-[#C65D47]"
                  >
                    Admin
                  </Button>
                </Link>
              )}
              {user.picture ? (
                <img
                  src={user.picture}
                  alt={user.name || "avatar"}
                  className="hidden h-8 w-8 rounded-full object-cover md:inline-block"
                  data-testid="header-avatar"
                />
              ) : null}
              <span
                className="hidden text-sm text-[#5C605E] md:inline"
                data-testid="header-user-email"
              >
                {user.email}
              </span>
              <Button
                variant="outline"
                onClick={handleLogout}
                data-testid="header-logout-button"
                className="border-[#0A0F0D] text-[#0A0F0D] hover:bg-[#0A0F0D] hover:text-[#FFFFFF]"
              >
                <SignOut size={16} weight="bold" className="mr-2" />
                Log out
              </Button>
            </>
          ) : (
            <>
              <Link to="/contractors">
                <Button
                  variant="ghost"
                  className="hidden text-[#0A0F0D] hover:text-[#C65D47] md:inline-flex"
                >
                  Find a Pro
                </Button>
              </Link>
              <Link to="/auth">
                <Button
                  data-testid="header-signin-button"
                  className="bg-[#0A0F0D] text-[#FFFFFF] hover:bg-[#C65D47]"
                >
                  Sign in
                </Button>
              </Link>
            </>
          )}
        </nav>
      </div>
    </header>
  );
};

export default Header;
